/**
 * Quotation Model - Processes API responses for quotation data
 */

export const getQuotations = (response) => {
  if (response && response.data && response.data.success === true) {
    const quotations = Array.isArray(response.data.data)
      ? response.data.data.map((q) => ({
        id: q.id || null,
        slack: q.slack || '',
        store_id: q.store_id || null,
        quotation_number: q.quotation_number || '',
        quotation_reference: q.quotation_reference || '',
        quotation_date: q.quotation_date || '',
        quotation_due_date: q.quotation_due_date || '',
        subject: q.subject || null,
        bill_to: q.bill_to || '',
        bill_to_id: q.bill_to_id || null,
        bill_to_code: q.bill_to_code || '',
        bill_to_name: q.bill_to_name || '',
        bill_to_email: q.bill_to_email || '',
        bill_to_contact: q.bill_to_contact || '',
        bill_to_address: q.bill_to_address || '',
        currency_name: q.currency_name || '',
        currency_code: q.currency_code || '',
        tax_option_id: q.tax_option_id || null,
        subtotal_excluding_tax: q.subtotal_excluding_tax || '0',
        total_discount_amount: q.total_discount_amount || '0',
        total_after_discount: q.total_after_discount || '0',
        total_tax_amount: q.total_tax_amount || '0',
        shipping_charge: q.shipping_charge || '0',
        packing_charge: q.packing_charge || '0',
        total_order_amount: q.total_order_amount || q.total_amount || q.amount || '0',
        notes: q.notes || '',
        status: q.status ?? 0,
        place_holder1: q.place_holder1 || null,
        place_holder2: q.place_holder2 || null,
        place_holder3: q.place_holder3 || null,
        place_holder4: q.place_holder4 || null,
        place_holder5: q.place_holder5 || null,
        created_at: q.created_at || '',
        updated_at: q.updated_at || '',
        createdAt: q.createdAt || q.created_at || '',
        updatedAt: q.updatedAt || q.updated_at || '',
        created_by: q.created_by,
        updated_by: q.updated_by,
        created_user: q.created_user || null,
        updated_user: q.updated_user || null,
        store: q.store ? {
          id: q.store.id || null,
          name: q.store.name || '',
          code: q.store.code || '',
          address: q.store.address || '',
          email: q.store.email || '',
          contact: q.store.contact || '',
          tax_number: q.store.tax_number || ''
        } : null,
        tax_option: q.tax_option || null,
        supplier: q.supplier || null,
        customer: q.customer || null,
        status_data: q.status_data ? {
          id: q.status_data.id || null,
          key: q.status_data.key || '',
          value: q.status_data.value || '',
          value_constant: q.status_data.value_constant || '',
          label: q.status_data.label || '',
          color: q.status_data.color || '',
          status: q.status_data.status ?? 0
        } : null,
        products: Array.isArray(q.products) ? q.products.map((p) => ({
          id: p.id || null,
          slack: p.slack || '',
          product_id: p.product_id || null,
          product_slack: p.product_slack || '',
          product_code: p.product_code || '',
          name: p.name || '',
          quantity: p.quantity || '0',
          amount_excluding_tax: p.amount_excluding_tax || '0',
          subtotal_amount_excluding_tax: p.subtotal_amount_excluding_tax || '0',
          discount_percentage: p.discount_percentage || '0',
          tax_percentage: p.tax_percentage || '0',
          discount_amount: p.discount_amount || '0',
          total_after_discount: p.total_after_discount || '0',
          tax_amount: p.tax_amount || '0',
          tax_components: p.tax_components || '[]',
          total_amount: p.total_amount || '0',
          status: p.status ?? 0,
          tax_code_id: p.tax_code_id || null,
          unit_of_measure: p.unit_of_measure || '',
          images: Array.isArray(p.images) ? p.images : [],
          place_holder1: p.place_holder1 || null,
          place_holder2: p.place_holder2 || null,
          place_holder3: p.place_holder3 || null,
          place_holder4: p.place_holder4 || null,
          place_holder5: p.place_holder5 || null
        })) : [],
        created_by_user: q.created_by && typeof q.created_by === 'object' ? {
          id: q.created_by.id || null,
          profile_img_url: q.created_by.profile_img_url || null,
          first_name: q.created_by.first_name || '',
          last_name: q.created_by.last_name || '',
          contact_number: q.created_by.contact_number || '',
          email: q.created_by.email || '',
          is_active: q.created_by.is_active ?? false
        } : null,
        requisition_info: q.requisition_info || null,
        related_entities: q.related_entities || null
      }))
      : []

    return {
      success: true,
      total: response.data.total || quotations.length,
      data: quotations
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch quotation list',
    data: []
  }
}

export const deleteQuotation = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Quotation deleted successfully'
    }
  }
  return {
    success: false,
    message: 'Failed to delete quotation'
  }
}

export const createQuotation = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Quotation created successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to create quotation',
    data: null
  }
}

export const updateQuotation = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Quotation updated successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to update quotation',
    data: null
  }
}

export const createRfq = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'RFQ created successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to create RFQ',
    data: null
  }
}
